var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFailIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    fill: "#E02020"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.2534 38.9602C39.8391 38.3744 39.8391 37.4246 39.2534 36.8388L30.4145 28L39.2534 19.1612C39.8391 18.5754 39.8391 17.6256 39.2534 17.0398C38.6676 16.4541 37.7178 16.4541 37.132 17.0398L28.2932 25.8787L20.1615 17.747C19.5757 17.1612 18.6259 17.1612 18.0402 17.747C17.4544 18.3327 17.4544 19.2825 18.0402 19.8683L26.1719 28L18.0402 36.1317C17.4544 36.7175 17.4544 37.6673 18.0402 38.253C18.6259 38.8388 19.5757 38.8388 20.1615 38.253L28.2932 30.1213L37.132 38.9602C37.7178 39.5459 38.6676 39.5459 39.2534 38.9602Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailIcon);
export default __webpack_public_path__ + "static/media/fail_icon.b5ba40b0c85d9c99f538068323d7bfbb.svg";
export { ForwardRef as ReactComponent };